import { CheckCircle2, Circle } from 'lucide-react'
import type { PasswordRule } from '../utils/passwordRequirements'

interface PasswordRequirementsChecklistProps {
  rules: PasswordRule[]
}

const PasswordRequirementsChecklist = ({ rules }: PasswordRequirementsChecklistProps) => {
  return (
    <ul className="space-y-1 mt-2" aria-label="Password requirements">
      {rules.map((rule) => (
        <li
          key={rule.id}
          className="flex items-center gap-2 text-sm"
          aria-label={`${rule.label}: ${rule.satisfied ? 'satisfied' : 'not satisfied'}`}
        >
          {rule.satisfied ? (
            <CheckCircle2
              className="w-4 h-4 text-green-500 shrink-0"
              aria-hidden="true"
            />
          ) : (
            <Circle
              className="w-4 h-4 text-gray-400 shrink-0"
              aria-hidden="true"
            />
          )}
          <span className={rule.satisfied ? 'text-green-700' : 'text-gray-500'}>
            {rule.label}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default PasswordRequirementsChecklist
